module.exports = __webpack_public_path__ + "img/son.be5030ca.webp";